export default __webpack_public_path__ + "static/media/Frame.a80f9c71.png";